module.exports = __webpack_public_path__ + "files/2216d77d9f915f2030af755546475324.svg";